import type { ReactElement } from 'react';
import { VenueCardTemplate } from './VenueCardTemplate';
import type {
  PreviewVenue,
  HighlightCapacityType
} from '../venueCardInternalModules/types';

export type Props = {
  venue: PreviewVenue;
  onClickVenueLink?: () => void;
  openInNewTab?: boolean;
  highlightCapacity?: HighlightCapacityType;
};

export function BasicVenueCard({
  venue,
  onClickVenueLink,
  openInNewTab = false,
  highlightCapacity
}: Props): ReactElement {
  return (
    <VenueCardTemplate
      venue={venue}
      onClickVenueLink={onClickVenueLink}
      openInNewTab={openInNewTab}
      highlightCapacity={highlightCapacity}
    />
  );
}
